import { useEffect } from "react";
import { HEADER } from "../constants";
import { getSessionStorage } from "../utils/storageUtils";
import { isTokenExpired } from "../utils/auth";
import { refreshTokens } from "../services/client";

export const useSessionManager = () => {
  /** ⏱ Background token refresh while active */
  useEffect(() => {
    const interval = setInterval(async () => {
      console.log("token interval call");
      const accessToken = getSessionStorage(HEADER.AUTHORIZATION);

      if (!accessToken) return;

      const aboutToExpire = isTokenExpired(accessToken, 30); // 30s buffer

      if (aboutToExpire) {
        console.log("🔑 Auth token expired or about to expire, refreshing...");
        try {
          await refreshTokens(); // SAFE call
        } catch (err) {
          console.warn("❌ Background token refresh failed", err);
        }
      }
    }, 10000); // every 10 seconds

    return () => clearInterval(interval);
  }, []);
};
